import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=be7f9b1a&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=be7f9b1a&prod&lang=scss&scoped=true"
import style1 from "./FirstPage.vue?vue&type=style&index=1&id=be7f9b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7f9b1a",
  null
  
)

export default component.exports